import { cn } from "../../../../lib/utils";

export default function MessageContainer({ isOutbound, children, className = "" }) {
  const isAgent = isOutbound;
  
  return (
    <div className={cn("flex", isAgent ? "justify-end" : "justify-start")}>
      <div
        className={cn(
          "max-w-[80%] md:max-w-[70%] rounded-lg px-3 py-2 shadow-sm relative",
          isAgent
            ? "bg-[#dcf8c6] dark:bg-emerald-500/25 text-gray-800 dark:text-slate-100 rounded-tr-none"
            : "bg-white dark:bg-slate-800 text-gray-800 dark:text-slate-100 rounded-tl-none",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
